import { ActivityDurationPage, AmountOfDirectorsPage, EachDirectorHasDecisionmakingPage, EstimatedResultPage, PartnerHasSharesPage, PrivateAssetsPage, TypeOfActivityPage } from "../../pages/keuzewijzerpages"
import { ActivityDuration, AmountOfDirectors, EstimatedResult, PrivateAssets, TypeOfActivity } from "./keuzewijzerenums"
import { ValueAndPage } from "../statemachine/valueandpage"

export class KeuzeWijzerState {
    amountOfDirectors: ValueAndPage<AmountOfDirectors>
    typeOfActivity: ValueAndPage<TypeOfActivity>
    estimatedResult: ValueAndPage<EstimatedResult>
    privateAssets: ValueAndPage<PrivateAssets>
    partnerHasShares: ValueAndPage<boolean>
    activityDuration: ValueAndPage<ActivityDuration>
    eachDirectorHasDecisionMaking: ValueAndPage<boolean>

    // I don't really like this constructor.
    // The name of the fields is present 4 times and the type 2 times. That's too much.
    // But for now, I can't think of a better way. At least typescript is preventing most copy paste errors...
    // Ideally I can get rid of all boilerplate so that this class becomes a simple list of fieldname-fieldtype-page.
    // E.g., amountOfDirectors - AmountOfDirectors - AmountOfDirectorsPage
    // I want to have a list of the above information with as little boilerplate as possible.
    constructor({ amountOfDirectors,
        typeOfActivity,
        estimatedResult,
        privateAssets,
        partnerHasShares,
        activityDuration,
        eachDirectorHasDecisionMaking }
        : {
            amountOfDirectors?: AmountOfDirectors,
            typeOfActivity?: TypeOfActivity,
            estimatedResult?: EstimatedResult,
            privateAssets?: PrivateAssets,
            partnerHasShares?: boolean,
            activityDuration?: ActivityDuration,
            eachDirectorHasDecisionMaking?: boolean
        } = {}) {
        this.amountOfDirectors = new ValueAndPage<AmountOfDirectors>(AmountOfDirectorsPage, amountOfDirectors)
        this.typeOfActivity = new ValueAndPage<TypeOfActivity>(TypeOfActivityPage, typeOfActivity)
        this.estimatedResult = new ValueAndPage<EstimatedResult>(EstimatedResultPage, estimatedResult)
        this.privateAssets = new ValueAndPage<PrivateAssets>(PrivateAssetsPage, privateAssets)
        this.partnerHasShares = new ValueAndPage<boolean>(PartnerHasSharesPage, partnerHasShares)
        this.activityDuration = new ValueAndPage<ActivityDuration>(ActivityDurationPage, activityDuration)
        this.eachDirectorHasDecisionMaking = new ValueAndPage<boolean>(EachDirectorHasDecisionmakingPage, eachDirectorHasDecisionMaking)
    }
}
